import { useEffect } from "react";
import DOMPurify from "dompurify";

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    "table", "thead", "tbody", "tfoot", "tr", "td", "th", "caption",
    "ul", "ol", "li", "b", "strong", "i", "em", "br", "p", "sub", "sup", "span",
  ],
  ALLOWED_ATTR: ["colspan", "rowspan", "type"],
};

const TAG_NAMES = SANITIZE_CONFIG.ALLOWED_TAGS.join("|");
const ATTR_NAMES = SANITIZE_CONFIG.ALLOWED_ATTR.join("|");

export const HTML_TAG = new RegExp(
  `<\\/?(${TAG_NAMES})(\\s+(${ATTR_NAMES})(\\s*=\\s*("[^"]*"|'[^']*'|\\d+))?)*\\s*\\/?>`,
  "i"
);

export const sanitizeHtml = (html) => DOMPurify.sanitize(html, SANITIZE_CONFIG);

export const MathJax = ({isMathJaxSet, expression}) => {
  const isHtml = typeof expression === "string" && HTML_TAG.test(expression);
  useEffect(()=> {
    if (!isMathJaxSet && typeof window?.MathJax !== "undefined") {
      window.MathJax.typeset()
    }
  },[]);
  if (isHtml) {
    return <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(expression) }} />;
  }
  return (
    <span>{expression}</span>
  );
};
